export const MERCURE_TOPIC_ADMIN_ORDERS = 'admin_orders';

/**
 * Список топиков Mercure, на которые подписывается админка.
 * Чтобы добавить или убрать топик — правим только этот массив.
 */
export const MERCURE_TOPICS: readonly string[] = [MERCURE_TOPIC_ADMIN_ORDERS];
